import colors from '@/assets/theme/colors';

export const defaultTheme = {
  fonts: ['sans-serif', 'Sintony'],
  colors,
  space: (value: number) => value * 8 + 'px',
  shadow: '0px 0px 10px 0px rgb(0 0 0 / 0.8)',
};
